import { render, staticRenderFns } from "./NetworkToggle.vue?vue&type=template&id=642b19af"
import script from "./NetworkToggle.vue?vue&type=script&lang=ts"
export * from "./NetworkToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports